<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Catalogo de Casas</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
        class="
          intro-y
          col-span-12
          flex flex-wrap
          sm:flex-nowrap
          items-center
          mt-2
        "
      >
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-72 relative text-gray-700 dark:text-gray-300">
            <input
              v-model="search"
              type="text"
              class="form-control w-72 box pr-10 placeholder-theme-13"
              placeholder="Buscar"
            />
            <SearchIcon
              class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
            />
          </div>
        </div>
        <div class="hidden md:block mx-auto text-gray-600"></div>
        <button
          class="btn btn-success shadow-md mr-2 w-60"
          @click="showModalCreate"
        >
          Nueva casa
        </button>
        <button
          class="btn btn-info shadow-md mr-2 w-60"
          @click="downloadReport"
        >
          Descargar reporte
        </button>
      </div>
      <!-- BEGIN: Data List -->
      <template v-if="houses.length">
        <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table class="table table-report -mt-2" aria-describedby="table">
            <thead>
              <tr>
                <th id="idH" class="whitespace-nowrap">ID</th>
                <th id="nombre" class="text-center whitespace-nowrap">
                  Nombre
                </th>
                <th id="contacto" class="text-center whitespace-nowrap">
                  Contacto
                </th>
                <th id="telefono" class="text-center whitespace-nowrap">
                  Télefono
                </th>
                <th id="direccion" class="text-center whitespace-nowrap">
                  Dirección
                </th>
                <th id="actionsH" class="text-center whitespace-nowrap">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="row in houses">
                <template v-if="checkShowRow(row)">
                  <tr :key="row.id">
                    <td class="w-20 font-medium">{{ row.id }}</td>
                    <td class="text-center w-10 font-medium">
                      {{ row.name }}
                    </td>
                    <td class="text-center w-10 font-medium">
                      {{ row.contact_info }}
                    </td>
                    <td class="text-center w-10 font-medium">
                      {{ row.main_phone }}
                    </td>
                    <td class="text-center w-40 font-medium">
                      {{ row.address }}<br />COL. {{ row.neighborhood
                      }}<br />CIUDAD {{ row.city }}
                    </td>
                    <td class="table-report__action w-56">
                      <div class="flex justify-center items-center">
                        <a
                          class="flex items-center mr-3 text-green-600"
                          href="javascript:;"
                          @click="setToEdit(row)"
                        >
                          <CheckSquareIcon class="w-4 h-4 mr-1" />
                          Editar
                        </a>
                        <a
                          href="javascript:;"
                          class="flex items-center text-red-700"
                          @click="setToDelete(row)"
                        >
                          <Trash2Icon class="w-4 h-4 mr-1" /> Eliminar
                        </a>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
        <!-- END: Data List -->
      </template>
    </div>
    <!-- BEGIN: MODALS -->

    <!-- BEGIN: Delete Confirmation Modal -->
    <div ref="deleteRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div v-if="rowSelected" class="modal-body p-0">
            <div class="p-5 text-center">
              <XCircleIcon class="w-16 h-16 text-red-700 mx-auto mt-3" />
              <div class="text-3xl mt-5">¿Estás seguro?</div>
              <div class="text-gray-600 mt-2">
                ¿Realmente quieres eliminar el registro
                <span style="font-weight: bold">{{ rowSelected.name }}</span
                >?
              </div>
            </div>
            <div class="px-5 pb-8 text-center">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-24 mr-1"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-danger w-24"
                @click="deleteAction"
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Delete Confirmation Modal -->

    <!-- BEGIN: Modal Add Row -->
    <div ref="createRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="createAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">Nuevo elemento</h2>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Nombre</label>
                <input
                  v-model="createForm.name"
                  type="text"
                  class="form-control"
                  placeholder="Nombre"
                  required
                />
                <template v-if="v$.createForm.name.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo nombre es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Información de contacto</label>
                <input
                  v-model="createForm.contactInfo"
                  type="text"
                  class="form-control"
                  placeholder="Información de contacto"
                />
                <template v-if="v$.createForm.contactInfo.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.contactInfo.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 250 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Correo</label>
                <input
                  v-model="createForm.email"
                  type="email"
                  class="form-control"
                  placeholder="Correo"
                />
                <template v-if="v$.createForm.email.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.email.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 250 caracteres</strong
                    >
                    <strong v-else-if="error.$validator === 'email'"
                      >El campo debe ser un correo</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Télefono principal</label>
                <input
                  v-model="createForm.mainPhone"
                  type="text"
                  class="form-control"
                  placeholder="Télefono principal"
                />
              </div>
              <div class="col-span-12">
                <label class="form-label">Télefono secundario</label>
                <input
                  v-model="createForm.secundaryPhone"
                  type="text"
                  class="form-control"
                  placeholder="Télefono secundario"
                />
              </div>
              <div class="col-span-12">
                <label class="form-label">Calle</label>
                <input
                  v-model="createForm.address"
                  type="text"
                  class="form-control"
                  placeholder="Calle"
                  required
                />
                <template v-if="v$.createForm.address.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.address.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Colonia</label>
                <input
                  v-model="createForm.neighborhood"
                  type="text"
                  class="form-control"
                  placeholder="Colonia"
                  required
                />
                <template v-if="v$.createForm.neighborhood.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.neighborhood.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Ciudad</label>
                <input
                  v-model="createForm.city"
                  type="text"
                  class="form-control"
                  placeholder="Ciudad"
                  required
                />
                <template v-if="v$.createForm.city.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.city.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Estado</label>
                <select
                  v-model="createForm.state"
                  data-placeholder="Selecciona el estado"
                  class="w-full form-select mt-1"
                  required
                >
                  <option v-for="item in states" :key="item" :value="item">
                    {{ item }}
                  </option>
                </select>
                <template v-if="v$.createForm.state.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.state.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Código Postal </label>
                <input
                  v-model="createForm.cp"
                  type="text"
                  class="form-control"
                  placeholder="Ciudad"
                  required
                />
                <template v-if="v$.createForm.cp.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.cp.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer text-right">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-20 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="v$.createForm.$invalid"
                class="btn btn-primary w-20"
                :class="{ 'btn-danger': v$.createForm.$invalid }"
              >
                Crear
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Add Row -->

    <!-- BEGIN: Modal Edit Row -->
    <div ref="editRow" class="modal" tabindex="-1" aria-hidden="true">
      <div v-if="rowSelected" class="modal-dialog">
        <form @submit.prevent="editAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">Modificar elemento</h2>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Nombre</label>
                <input
                  v-model="editForm.name"
                  type="text"
                  class="form-control"
                  placeholder="Nombre"
                  required
                />
                <template v-if="v$.editForm.name.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo nombre es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Información de contacto</label>
                <input
                  v-model="editForm.contactInfo"
                  type="text"
                  class="form-control"
                  placeholder="Información de contacto"
                />
                <template v-if="v$.editForm.contactInfo.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.contactInfo.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 250 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Correo</label>
                <input
                  v-model="editForm.email"
                  type="email"
                  class="form-control"
                  placeholder="Correo"
                />
                <template v-if="v$.editForm.email.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.email.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 250 caracteres</strong
                    >
                    <strong v-else-if="error.$validator === 'email'"
                      >El campo debe ser un correo</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Télefono principal</label>
                <input
                  v-model="editForm.mainPhone"
                  type="text"
                  class="form-control"
                  placeholder="Télefono principal"
                />
              </div>
              <div class="col-span-12">
                <label class="form-label">Télefono secundario</label>
                <input
                  v-model="editForm.secundaryPhone"
                  type="text"
                  class="form-control"
                  placeholder="Télefono secundario"
                />
              </div>
              <div class="col-span-12">
                <label class="form-label">Calle</label>
                <input
                  v-model="editForm.address"
                  type="text"
                  class="form-control"
                  placeholder="Calle"
                  required
                />
                <template v-if="v$.editForm.address.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.address.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Colonia</label>
                <input
                  v-model="editForm.neighborhood"
                  type="text"
                  class="form-control"
                  placeholder="Colonia"
                  required
                />
                <template v-if="v$.editForm.neighborhood.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.neighborhood.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Ciudad</label>
                <input
                  v-model="editForm.city"
                  type="text"
                  class="form-control"
                  placeholder="Ciudad"
                  required
                />
                <template v-if="v$.editForm.city.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.city.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Estado</label>
                <select
                  v-model="editForm.state"
                  data-placeholder="Selecciona el estado"
                  class="w-full form-select mt-1"
                  required
                >
                  <option v-for="item in states" :key="item" :value="item">
                    {{ item }}
                  </option>
                </select>
                <template v-if="v$.editForm.state.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.state.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12">
                <label class="form-label">Código Postal </label>
                <input
                  v-model="editForm.cp"
                  type="text"
                  class="form-control"
                  placeholder="Ciudad"
                  required
                />
                <template v-if="v$.editForm.cp.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.cp.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer text-right">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-20 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="v$.editForm.$invalid"
                class="btn btn-primary w-20"
                :class="{ 'btn-danger': v$.editForm.$invalid }"
              >
                Modificar
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Edit Row -->

    <!-- END: MODALS -->
  </div>
</template>

<script>
import { cleanSession, getFirstErrorMessage } from '../../../utils/tools'
import states from '../../../utils/states'
import useVuelidate from '@vuelidate/core'
import { maxLength, required, email } from '@vuelidate/validators'
import { saveAs } from 'file-saver'
import moment from 'moment-timezone'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      houses: [],
      states: states,
      rowSelected: undefined,
      createForm: {
        name: '',
        contactInfo: '',
        email: '',
        address: '',
        neighborhood: '',
        city: '',
        state: '',
        cp: '',
        mainPhone: '',
        secundaryPhone: ''
      },
      editForm: {
        name: '',
        contactInfo: '',
        email: '',
        address: '',
        neighborhood: '',
        city: '',
        state: '',
        cp: '',
        mainPhone: '',
        secundaryPhone: ''
      },
      search: ''
    }
  },
  validations() {
    return {
      createForm: {
        name: { required, $autoDirty: true, maxLength: maxLength(100) },
        contactInfo: { $autoDirty: true, maxLength: maxLength(250) },
        email: { $autoDirty: true, email, maxLength: maxLength(250) },
        address: { required, $autoDirty: true, maxLength: maxLength(100) },
        neighborhood: { required, $autoDirty: true, maxLength: maxLength(100) },
        city: { required, $autoDirty: true, maxLength: maxLength(100) },
        state: { required, $autoDirty: true },
        cp: { required, $autoDirty: true }
      },
      editForm: {
        name: { required, $autoDirty: true, maxLength: maxLength(100) },
        contactInfo: { $autoDirty: true, maxLength: maxLength(250) },
        email: { $autoDirty: true, email, maxLength: maxLength(250) },
        address: { required, $autoDirty: true, maxLength: maxLength(100) },
        neighborhood: { required, $autoDirty: true, maxLength: maxLength(100) },
        city: { required, $autoDirty: true, maxLength: maxLength(100) },
        state: { required, $autoDirty: true },
        cp: { required, $autoDirty: true }
      }
    }
  },
  validationConfig: {
    $lazy: false
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    await this.getInitialData()
    this.$store.commit('main/setShowSpinner', false)
  },
  methods: {
    async getInitialData() {
      try {
        const response = await this.axios.get('/houses', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.houses = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    checkShowRow(row) {
      if (this.search) {
        return (
          row.name.toUpperCase().includes(this.search.trim().toUpperCase()) ||
          (row.contact_info &&
            row.contact_info
              .toUpperCase()
              .includes(this.search.trim().toUpperCase())) ||
          row.address
            .toUpperCase()
            .includes(this.search.trim().toUpperCase()) ||
          row.city.toUpperCase().includes(this.search.trim().toUpperCase()) ||
          row.neighborhood
            .toUpperCase()
            .includes(this.search.trim().toUpperCase())
        )
      }
      return true
    },
    showModalCreate() {
      this.createForm = {
        name: '',
        contactInfo: '',
        email: '',
        address: '',
        neighborhood: '',
        city: '',
        state: '',
        cp: '',
        mainPhone: '',
        secundaryPhone: ''
      }
      this.v$.$reset()
      const modal = this.$refs.createRow
      cash(modal).modal('show')
    },
    async createAction() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          '/create-house',
          {
            name: this.createForm.name,
            contact_info: this.createForm.contactInfo,
            email: this.createForm.email,
            address: this.createForm.address,
            neighborhood: this.createForm.neighborhood,
            city: this.createForm.city,
            state: this.createForm.state,
            cp: this.createForm.cp,
            country: 'México',
            main_phone: this.createForm.mainPhone,
            secundary_phone: this.createForm.secundaryPhone
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        await this.getInitialData()
        const modal = this.$refs.createRow
        cash(modal).modal('hide')
        this.$toast.success('El registro se ha creado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    setToDelete(row) {
      this.rowSelected = row
      const modal = this.$refs.deleteRow
      cash(modal).modal('show')
    },
    async deleteAction() {
      const modal = this.$refs.deleteRow
      cash(modal).modal('hide')
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-house/${this.rowSelected.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.getInitialData()
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    setToEdit(row) {
      this.rowSelected = row
      this.editForm = {
        name: this.rowSelected.name,
        contactInfo: this.rowSelected.contact_info,
        email: this.rowSelected.email,
        address: this.rowSelected.address,
        neighborhood: this.rowSelected.neighborhood,
        city: this.rowSelected.city,
        state: this.rowSelected.state,
        cp: this.rowSelected.cp,
        mainPhone: this.rowSelected.main_phone,
        secundaryPhone: this.rowSelected.secundary_phone
      }
      this.v$.$reset()
      const modal = this.$refs.editRow
      cash(modal).modal('show')
    },
    async editAction() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const body = {
          name: this.editForm.name,
          contact_info: this.editForm.contactInfo,
          email: this.editForm.email,
          address: this.editForm.address,
          neighborhood: this.editForm.neighborhood,
          city: this.editForm.city,
          state: this.editForm.state,
          cp: this.editForm.cp,
          country: 'México',
          main_phone: this.editForm.mainPhone,
          secundary_phone: this.editForm.secundaryPhone
        }
        await this.axios.put(`/update-house/${this.rowSelected.id}`, body, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.getInitialData()
        const modal = this.$refs.editRow
        cash(modal).modal('hide')
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async downloadReport() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get('/house-file', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          },
          responseType: 'blob'
        })
        saveAs(
          response.data,
          `Casas Información ${moment().format('DD-MM-YYYY')}.xlsx`
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    }
  }
}
</script>
